<form [formGroup]="form" class="flex flex-col space-y-2">
    @if (!isReadOnly()) {
        <div
            class="flex flex-col justify-end space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2 mb-2"
        >
            <span
                [matTooltipPosition]="'left'"
                [matTooltip]="
                    checkSafeHarborButtonDisabled()
                        ? checkSafeHarborMessages.validLocationFrequenciesAntennasInfoRequired
                        : ''
                "
            >
                <button
                    mat-button
                    mat-flat-button
                    color="primary"
                    [disabled]="checkSafeHarborButtonDisabled()"
                    (click)="onCheckSafeHarborClick()"
                >
                    Check Safe Harbor
                </button>
            </span>
        </div>
    }

    <mat-accordion>
        <mat-expansion-panel [expanded]="shouldExpandLocationTab()">
            <mat-expansion-panel-header>
                <mat-panel-title
                    ><h1
                        class="!rounded-full mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base !text-sm !font-medium"
                    >
                        {{ getLocationTabTitle() }}
                    </h1></mat-panel-title
                >
            </mat-expansion-panel-header>
            @if (addScheduleDReady === true) {
                <app-schedule-d-base
                    (saveScheduleD)="
                        saveScheduleD($event.form, $event.isSubmitAction)
                    "
                    [atMaximumFixedLocations]="atMaximumFixedLocations()"
                    (formChange)="scheduleDFormChanged($event)"
                    [scheduleDs]="scheduleDs()"
                ></app-schedule-d-base>
            }
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <div class="flex space-x-2 items-center">
                        <h1
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Locations
                        </h1>
                        @if (anyScheduleDsInvalid()) {
                            <img
                                src="assets/svg/error_icon.svg"
                                alt="Error Icon"
                            />
                            @if (exceededMaximumFixedLocations()) {
                                <p
                                    class="!mb-0 !ml-2 text-error-600 font-medium"
                                >
                                    {{
                                        scheduleDValidationMessages.exceededMaximumFixedLocations
                                    }}
                                </p>
                            }
                        }
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <app-grid-toolbar
                [gridApi]="gridApis[schedulesDAndHGridType.scheduleDs]"
                [options]="scheduleDGridToolbarOptions"
            ></app-grid-toolbar>
            <ag-grid-angular
                [context]="
                    initializeGridContext(schedulesDAndHGridType.scheduleDs)
                "
                [rowData]="rowData[schedulesDAndHGridType.scheduleDs]"
                [gridOptions]="scheduleDGridOptions"
                (gridReady)="
                    onGridReady($event, schedulesDAndHGridType.scheduleDs)
                "
                class="ag-theme-quartz h-[370px] w-full"
            >
            </ag-grid-angular>
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <div class="flex space-x-2">
                        <h1
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Antennas, Frequencies
                        </h1>
                        @if (anyAntennasOrFrequenciesInvalid()) {
                            <img
                                src="assets/svg/error_icon.svg"
                                alt="Error Icon"
                            />
                        }
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div>{{ gridTooltipMessages.headerTooltipInfoNote }}</div>

            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="flex items-center space-x-1">
                            <span>Antennas</span>
                            @if (anyAntennasInvalid()) {
                                <img
                                    src="assets/svg/error_icon.svg"
                                    alt="Error Icon"
                                />
                            }
                        </div>
                    </ng-template>

                    <ng-template matTabContent>
                        @if (shouldShowAddAntennaButton()) {
                            <div class="flex items-center">
                                <button
                                    color="primary"
                                    class="!rounded-full"
                                    (click)="addAntennaToGrid()"
                                    type="button"
                                    mat-flat-button
                                >
                                    Add Antenna
                                </button>

                                @if (!allScheduleDsHaveAnAntenna()) {
                                    <p
                                        class="!mb-0 !ml-2 text-error-600 font-medium"
                                    >
                                        {{
                                            antennaValidationMessages.scheduleDsMustHaveAtLeastOneAntenna
                                        }}
                                    </p>
                                }
                            </div>
                        }

                        <app-grid-toolbar
                            [gridApi]="
                                gridApis[schedulesDAndHGridType.antennas]
                            "
                            [options]="antennasGridToolbarOptions"
                        ></app-grid-toolbar>
                        <ag-grid-angular
                            [context]="
                                initializeGridContext(
                                    schedulesDAndHGridType.antennas
                                )
                            "
                            [rowData]="rowData[schedulesDAndHGridType.antennas]"
                            [gridOptions]="antennaGridOptions"
                            (gridReady)="
                                onGridReady(
                                    $event,
                                    schedulesDAndHGridType.antennas
                                )
                            "
                            overlayNoRowsTemplate="Please enter a location before entering antenna information"
                            class="ag-theme-quartz h-[370px] w-full"
                        >
                        </ag-grid-angular>
                    </ng-template>
                </mat-tab>

                <mat-tab label="Frequencies">
                    <ng-template mat-tab-label>
                        <div class="flex items-center space-x-1">
                            <span>Frequencies</span>
                            @if (anyFrequenciesInvalid()) {
                                <img
                                    src="assets/svg/error_icon.svg"
                                    alt="Error Icon"
                                />
                            }
                        </div>
                    </ng-template>
                    <ng-template matTabContent>
                        <div
                            class="flex flex-col space-y-1 lg:flex-row lg:items-center lg:justify-between"
                        >
                            @if (shouldShowAddFrequencyButton()) {
                                <div class="flex flex-col space-y-1">
                                    <div class="flex items-center">
                                        <button
                                            color="primary"
                                            class="!rounded-full"
                                            (click)="addFrequencyToGrid()"
                                            type="button"
                                            mat-flat-button
                                        >
                                            Add Frequency
                                        </button>

                                        @if (
                                            !allUndeletedAntennasHaveAnUndeletedFrequency()
                                        ) {
                                            <p
                                                class="!mb-0 !ml-2 text-error-600 font-medium"
                                            >
                                                {{
                                                    frequencyValidationMessages.antennasMustHaveAtLeastOneFrequency
                                                }}
                                            </p>
                                        }
                                    </div>

                                    <p class="text-sm text-warn-700">
                                        <span class="font-medium">**</span> =
                                        Requested Emission Designator not part
                                        of the approved CEVO List
                                    </p>
                                </div>
                            }

                            @if (!isReadOnly()) {
                                <div>
                                    <button
                                        color="primary"
                                        class="!rounded-full"
                                        (click)="
                                            this.applicationPageFacadeService.applicationStateService.IsExistingLicenseApplication()
                                                ? openMultiRowEmissionDesignatorOperationExistingLicense()
                                                : openMultiRowEmissionDesignatorOperation()
                                        "
                                        type="button"
                                        [disabled]="
                                            !areMultipleEmissionDesignatorsSelected()
                                        "
                                        mat-flat-button
                                    >
                                        Multi-row Emission Designator Operation
                                    </button>
                                </div>
                            }
                        </div>

                        <app-grid-toolbar
                            [gridApi]="
                                gridApis[schedulesDAndHGridType.frequencies]
                            "
                            [options]="frequenciesGridToolbarOptions"
                        ></app-grid-toolbar>
                        <ag-grid-angular
                            [context]="
                                initializeGridContext(
                                    schedulesDAndHGridType.frequencies
                                )
                            "
                            [rowData]="
                                rowData[schedulesDAndHGridType.frequencies]
                            "
                            [gridOptions]="frequencyGridOptions"
                            [components]="frequencyGridComponents"
                            (gridReady)="
                                onGridReady(
                                    $event,
                                    schedulesDAndHGridType.frequencies
                                )
                            "
                            class="ag-theme-quartz h-[600px] w-full"
                        >
                        </ag-grid-angular>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
    </mat-accordion>
</form>
